<a mat-stroked-button class="google-login-button">
	<img
		class="obg-m-google-login-icon"
		height="24px"
		width="24px"
		obgImageContent="general.social-login.google.logo"
		obgImageContentGroup="general"
	/>
	<span>{{ "login.type.google.button" | translate }}</span>
</a>
